export default __webpack_public_path__ + "static/media/Taunt_Battleworld.40df4a98.jpg";